export default __webpack_public_path__ + "static/media/leito.92374ff4.svg";